export enum AnnouncementCategory {
    ProductUpdate,
    ProductMaintenanceUpdate,
    PlannedMaintenance,
    FeatureDeprecationNotice,
    TrainingAnnouncement,
}

export const announcementCategoryOptions = [
    { label: "Product Update", value: AnnouncementCategory.ProductUpdate },
    { label: "Product Maintenance Update", value: AnnouncementCategory.ProductMaintenanceUpdate },
    { label: "Planned Maintenance", value: AnnouncementCategory.PlannedMaintenance },
    { label: "Feature Deprecation Notice", value: AnnouncementCategory.FeatureDeprecationNotice },
    { label: "Training Announcement", value: AnnouncementCategory.TrainingAnnouncement },
   
];

